export default "__VITE_ASSET__Ch6b7UIC__"